import { type GetHookResponse } from '../hooks'
import { apiKeyKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type ApiKeyListInput, type ApiKeyListSuccess, type ApiKeyData } from '@terros/common'

export function useApiKeys(): GetHookResponse<ApiKeyData[]> {
  return useTantalimQuery<ApiKeyListInput, ApiKeyListSuccess, ApiKeyData[]>({
    url: '/apikey/list',
    queryKey: apiKeyKey(),
    input: {},
    convertResponse: (data) => {
      return data.keys
    },
  })
}
